function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useState } from 'react';
var TAB_KEY_CODE = 9;
var SPACE_KEY_CODE = 32;
export var MOUSE_MODE_CLASS = 'bbui-mouse-mode';

var addMouseModeClass = function addMouseModeClass(container) {
  return container.classList.add(MOUSE_MODE_CLASS);
};

var removeMouseModeClass = function removeMouseModeClass(container) {
  return container.classList.remove(MOUSE_MODE_CLASS);
};
/**
 * Unlike what the name suggests, this doesn't technically manage focus. All it does is add a class
 * based on users' choice of navigation (mouse or keyboard). It's up to each component to decide
 * what to do with this information.
 */


export function withFocusManager( // eslint-disable-next-line @typescript-eslint/no-explicit-any
WrappedComponent) {
  var onMouseMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : addMouseModeClass;
  var onKeyMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : removeMouseModeClass;
  return function FocusManager(_ref) {
    var container = _ref.container,
        rest = _objectWithoutProperties(_ref, ["container"]);

    var derivedContainer = container || (document ? document.body : null);

    var _useState = useState(true),
        _useState2 = _slicedToArray(_useState, 2),
        usingMouse = _useState2[0],
        setUsingMouse = _useState2[1];

    var handleKeyDown = function handleKeyDown(e) {
      if (e.which === TAB_KEY_CODE || e.which === SPACE_KEY_CODE) {
        setUsingMouse(false);
      }
    };

    var handleMouseDown = function handleMouseDown() {
      setUsingMouse(true);
    };

    useEffect(function () {
      if (!derivedContainer) {
        // eslint-disable-next-line no-console
        console.error('Invalid container for BBUIFocusManager');
        return;
      }

      if (usingMouse) {
        onMouseMode(derivedContainer);
        derivedContainer.removeEventListener('mousedown', handleMouseDown);
        derivedContainer.addEventListener('keydown', handleKeyDown);
      } else {
        onKeyMode(derivedContainer);
        derivedContainer.removeEventListener('keydown', handleKeyDown);
        derivedContainer.addEventListener('mousedown', handleMouseDown);
      }
    }, [usingMouse]);
    return React.createElement(WrappedComponent, rest);
  };
}
var FocusManager = withFocusManager(function () {
  return null;
});
export default FocusManager;